import 'react-tippy/dist/tippy.css';
import {useRef, useState} from 'react';
import {useIntl} from 'react-intl';
import {ReactComponent as Chevron} from 'assets/icons/chevron-down.svg';
import {ReactComponent as TooltipIcon} from 'assets/icons/tooltip.svg';
import {Tooltip} from 'react-tippy';

const AccordionWrapper = ({label, expanded = true, tooltip, children}) => {
  const intl = useIntl();
  const content = useRef(null);
  const [isExpanded, setExpanded] = useState(expanded);

  if (!label) {
    return '';
  }

  return (
    <div className="accordion-wrapper">
      <button className="button--clear accordion-wrapper__heading"
              aria-expanded={isExpanded}
              onClick={() => setExpanded(!isExpanded)}>
        {intl.formatMessage({id: label})}

        {
          tooltip && typeof tooltip === 'string' && tooltip.trim() !== '' ? (
            <Tooltip
              title={intl.formatMessage({id: tooltip})}
              className='ml-10'
              trigger="mouseenter focus click"
              arrow={true}
              tabIndex={0}
              inertia={true}
              interactive={true}>
              <TooltipIcon/>
            </Tooltip>
          ) : null
        }

        <Chevron className='ml-auto'/>
      </button>
      <div ref={content}
           className={`accordion-wrapper__content ${isExpanded ? 'expanded' : ''}`}
           aria-hidden={!isExpanded}
           style={{maxHeight: !isExpanded ? '0' : ''}}>
        <div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AccordionWrapper;
